module.exports = __webpack_public_path__ + "static/media/mobile_icon.63b6c869.png";